import { PaginationModel, PasswordUpdateModel, UserPutModel } from '../models';
import { PasswordUpdateSchema, UserBalanceSchema, UserPutSchema, UserReferralsResponseSchema, UserReferralsSchema, UserSchema } from '../schemas';
import { validateWithSchema } from '../utils';
import { axiosForImage, axiosSecure, handleError, handleResponse, removeDynamicParams, RequestResponse } from './config';

export const getUser = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/users`)
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const getUserReferrals = async (pagination: PaginationModel): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/users/referrals`, { params: pagination })
      .then((response) => handleResponse(response, UserReferralsResponseSchema))
      .catch(handleError);
};

export const getUserBalance = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/users/balance`)
      .then((response) => handleResponse(response, UserBalanceSchema))
      .catch(handleError);
};

export const putUser = async (userPut: UserPutModel): Promise<RequestResponse> => {
   return await axiosSecure
      .put('/users', validateWithSchema(UserPutSchema, userPut))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const uploadAvatar = async (data: FormData): Promise<RequestResponse> => {
   return await axiosForImage.post('/users/avatar', data).then(handleResponse).catch(handleError);
};

export const putUserPassword = async (passwordPut: PasswordUpdateModel): Promise<RequestResponse> => {
   return await axiosSecure
      .put('/users/password', validateWithSchema(PasswordUpdateSchema, passwordPut))
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};

export const addReferredBy = async (code: string): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/users/referred-by', { referralCode: code })
      .then((response) => handleResponse(response, UserSchema))
      .catch(handleError);
};
